<div class="NgxEditor__Wrapper">
    <ngx-editor-menu [colorPresets]="colorPresets" [editor]="editor" [toolbar]="toolbar" [disabled]="formControl.disabled"> </ngx-editor-menu>
    <ngx-editor [outputFormat]="'html'" [placeholder]="'general.typeHere'|translate|firstUpper" [editor]="editor" [formControl]="formControl"></ngx-editor>
</div>
